import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  SIGNIN,
  FORGETPASSWORD,
  MECOURSES,
  COURSES,
  USERS,
  REPORTS,
  SUBSCRIPTIONS,
  TEMPLATES,
  WELCOME,
  INICIO,
  NOTIFICATIONS,
  GOOGLE,
  MECOURSE,
  POSITIONCALCULATOR,
  MAILSECUENCE,
  ANNOUNCEMENTDETAIL,
  DIAGNOSTIC_QUESTIONS,
  DIAGNOSTIC_ANSWERS,
  TRADING_METRICS,
  TRADING_METRICS_ADMIN,
  LIQUID_ASSETS,
  LIQUID_ASSETS_ADMIN,
  FINANCIAL_GOALS,
  FINANCIAL_METRICS,
  FINANCIAL_METRICS_ADMIN,
} from './routes';

export function useNavigationCore() {
  const navigate = useNavigate();

  const goToSignIn = useCallback(() => {
    navigate(SIGNIN);
  }, [navigate]);

  const goToForgetPassword = useCallback(() => {
    navigate(FORGETPASSWORD);
  }, [navigate]);

  const goToWelcome = useCallback(() => {
    navigate(WELCOME);
  }, [navigate]);

  const goToInicio = useCallback(() => {
    navigate(INICIO);
  }, [navigate]);

  const goToMeCourses = useCallback(() => {
    navigate(MECOURSES);
  }, [navigate]);

  const goToMeCourse = useCallback(
    (id: string, classId?: string) => {
      if (classId) {
        navigate(`${MECOURSE}/${id}/classes?classId=${classId}`);
      } else {
        navigate(`${MECOURSE}/${id}/classes`);
      }
    },
    [navigate]
  );

  const goToSecuenceTasks = useCallback(
    (id: string) => {
      navigate(`${MAILSECUENCE}/${id}`);
    },
    [navigate]
  );

  const goToPositionCalculator = useCallback(
    (id: string) => {
      navigate(`${MECOURSE}/${id}/position-calculator`);
    },
    [navigate]
  );

  const goToAlliance = useCallback(
    (id: string) => {
      navigate(`${MECOURSE}/${id}/alliance`);
    },
    [navigate]
  );

  const goToCalendar = useCallback(
    (id: string) => {
      navigate(`${MECOURSE}/${id}/calendar`);
    },
    [navigate]
  );

  const goToCourseReports = useCallback(
    (id: string) => {
      navigate(`${MECOURSE}/${id}/reports`);
    },
    [navigate]
  );

  const goToForum = useCallback(
    (id: string, subjectId?: string) => {
      if (subjectId) {
        navigate(`${MECOURSE}/${id}/forum?subjectId=${subjectId}`);
      } else {
        navigate(`${MECOURSE}/${id}/forum`);
      }
    },
    [navigate]
  );

  const goToUsers = useCallback(() => {
    navigate(USERS);
  }, [navigate]);

  const goToUser = useCallback(
    (id: string) => {
      navigate(`${USERS}/${id}`);
    },
    [navigate]
  );

  const goToCourses = useCallback(() => {
    navigate(COURSES);
  }, [navigate]);

  const goToCourse = useCallback(
    (id: string) => {
      navigate(`${COURSES}/${id}`);
    },
    [navigate]
  );

  const goToReports = useCallback(() => {
    navigate(REPORTS);
  }, [navigate]);

  const goToTemplates = useCallback(() => {
    navigate(TEMPLATES);
  }, [navigate]);

  const goToSubscriptions = useCallback(() => {
    navigate(SUBSCRIPTIONS);
  }, [navigate]);

  const goToNotifications = useCallback(() => {
    navigate(NOTIFICATIONS);
  }, [navigate]);

  const goToPositionCalculatorValues = useCallback(() => {
    navigate(POSITIONCALCULATOR);
  }, [navigate]);

  const goToGoogle = useCallback(() => {
    navigate(GOOGLE);
  }, [navigate]);

  const goToAnnouncement = useCallback((id: number, state?: any) => {
    navigate(`${ANNOUNCEMENTDETAIL}/${id}`, state ? { state } : undefined);
  }, [navigate]);

  const goToDiagnosticQuestions = useCallback(
    (id: string) => {
      navigate(DIAGNOSTIC_QUESTIONS.replace(':id', id));
    },
    [navigate]
  );

  const goToDiagnosticAnswers = useCallback(() => {
    navigate(DIAGNOSTIC_ANSWERS);
  }, [navigate]);

  const goToTradingMetrics = useCallback(
    (id: string) => {
      navigate(TRADING_METRICS.replace(':id', id));
    },
    [navigate]
  );

  const goToTradingMetricsAdmin = useCallback(() => {
    navigate(TRADING_METRICS_ADMIN);
  }, [navigate]);

  const goToLiquidAssets = useCallback(
    (id: string) => {
      navigate(LIQUID_ASSETS.replace(':id', id));
    },
    [navigate]
  );

  const goToLiquidAssetsAdmin = useCallback(() => {
    navigate(LIQUID_ASSETS_ADMIN);
  }, [navigate]);

  const goToRealEstate = useCallback((id?: string) => {
    if (id) {
      navigate(`/dashboard/me/course/${id}/real-estate`);
    } else {
      // Admin panel de departamentos
      navigate('/dashboard/tools/real-estate');
    }
  }, [navigate]);

  const goToFinancialGoals = useCallback((id?: string) => {
    if (id) {
      navigate(FINANCIAL_GOALS.replace(':id', id));
    } else {
      navigate('/dashboard/tools/financial-goals');
    }
  }, [navigate]);

  const goToFinancialMetrics = useCallback((id?: string) => {
    if (id) {
      navigate(FINANCIAL_METRICS.replace(':id', id));
    } else {
      navigate(FINANCIAL_METRICS_ADMIN);
    }
  }, [navigate]);

  return {
    goToInicio,
    goToSignIn,
    goToForgetPassword,
    goToWelcome,
    goToMeCourses,
    goToMeCourse,
    goToPositionCalculator,
    goToCalendar,
    goToReports,
    goToUsers,
    goToUser,
    goToCourses,
    goToCourse,
    goToCourseReports,
    goToTemplates,
    goToSubscriptions,
    goToNotifications,
    goToPositionCalculatorValues,
    goToForum,
    goToSecuenceTasks,
    goToGoogle,
    goToAlliance,
    goToAnnouncement,
    goToDiagnosticQuestions,
    goToDiagnosticAnswers,
    goToTradingMetrics,
    goToTradingMetricsAdmin,
    goToLiquidAssets,
    goToLiquidAssetsAdmin,
    goToRealEstate,
    goToFinancialGoals,
    goToFinancialMetrics,
  };
}
